import { useRef } from 'react'
import { CSSTransition } from 'react-transition-group'

import NavigatableIntegrationWidgetCard from 'components/integrations/NavigatableIntegrationWidgetCard'
import AnimateAutoHeight from 'components/AnimateAutoHeight'
import SubscriptionDetail from 'components/integrations/RechargeWidgetCard/Subscriptions/Detail'
import OrderDetail from 'components/integrations/RechargeWidgetCard/Orders/Detail'
import UpcomingOrderDetail from 'components/integrations/RechargeWidgetCard/UpcomingOrders/Detail'

export default function RechargeDetail({
  navigatableState,
  integration,
  className,
}) {
  const { type } = navigatableState || {}
  const subscriptionNodeRef = useRef(null)
  const orderNodeRef = useRef(null)
  const chargeNodeRef = useRef(null)

  return (
    <AnimateAutoHeight duration={300}>
      <NavigatableIntegrationWidgetCard.AnimatedLeftRight>
        <CSSTransition
          className="index"
          classNames="index"
          in={type === 'subscription'}
          nodeRef={subscriptionNodeRef}
          timeout={300}
        >
          <div ref={subscriptionNodeRef} className="index">
            <SubscriptionDetail
              integration={integration}
              className={className}
            />
          </div>
        </CSSTransition>
        <CSSTransition
          className="detail"
          classNames="detail"
          in={type === 'order'}
          nodeRef={orderNodeRef}
          timeout={300}
        >
          <div ref={orderNodeRef} className="detail">
            <OrderDetail integration={integration} className={className} />
          </div>
        </CSSTransition>
        <CSSTransition
          className="detail"
          classNames="detail"
          in={type === 'charge'}
          nodeRef={chargeNodeRef}
          timeout={300}
        >
          <div ref={chargeNodeRef} className="detail">
            <UpcomingOrderDetail
              integration={integration}
              className={className}
            />
          </div>
        </CSSTransition>
      </NavigatableIntegrationWidgetCard.AnimatedLeftRight>
    </AnimateAutoHeight>
  )
}
